import React from "react";

/*
 * The storefront header's icons, copied path-for-path from hanamaru
 * `src/icons/*.tsx` so the two headers draw the same glyphs. Inline rather than
 * <img> so they take `currentColor` -- the dark seasonal theme turns them white.
 */

export const CartIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" fill="currentColor" viewBox="0 0 20 19" className={className} aria-hidden="true">
    <path d="m20 2.7-.4-.2H3.8L3.3.3Q3.3.1 3 0H.4Q0 0 0 .4t.4.4h2.2l2 10.2a3 3 0 0 0 2.8 2.3H17q.4 0 .4-.4t-.4-.4H7.5a2 2 0 0 1-1.7-.9L18 9.9l.3-.3L20 2.9zm-2.4 6.5L5.4 10.8 4 3.3H19zM7 14.2a2 2 0 0 0-2.1 2c0 1.2 1 2.1 2 2.1a2 2 0 0 0 2.2-2A2 2 0 0 0 7 14.2m0 3.3q-1.2-.2-1.3-1.2.1-1.4 1.3-1.3t1.2 1.3c.1 1.2-.6 1.2-1.2 1.2m8.3-3.3a2 2 0 0 0-2 2q.1 2 2 2.1a2 2 0 0 0 2.1-2 2 2 0 0 0-2-2.1m0 3.3q-1.1-.2-1.2-1.2c-.1-1 .6-1.3 1.2-1.3q1.2.1 1.3 1.3c0 1.2-.6 1.2-1.3 1.2" />
  </svg>
);

export const HistoryIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor" className={className} aria-hidden="true">
    <path d="M1.65 8.65c0 .07-.04 1.32.3 2.66l-1.1-.67a.55.55 0 0 0-.77.22.6.6 0 0 0 .2.82l2.56 1.57.1.05.06.02h.07q.08.02.08.01h.07l.15-.06.12-.08.1-.12.03-.06.03-.05 1.02-2.67a.6.6 0 0 0-.31-.78.56.56 0 0 0-.74.33l-.53 1.37c-.34-1.23-.3-2.5-.3-2.54 0-4.06 3.12-7.37 6.97-7.37s6.96 3.3 6.96 7.37-3.12 7.38-6.96 7.38a.6.6 0 0 0-.57.6c0 .33.25.6.57.6 4.46 0 8.1-3.84 8.1-8.58S14.22.1 9.76.1c-4.47 0-8.1 3.85-8.1 8.56" />
    <path d="m11.1 9.77.03-.02.1-.17.02-.05.03-.16v-.03l-.14-5.16a.63.63 0 0 0-.6-.6.55.55 0 0 0-.57.57l.14 4.76-3 1.16a.56.56 0 0 0-.3.75c.14.3.48.46.78.34l3.35-1.3z" />
  </svg>
);

export const WishlistIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" className={className} aria-hidden="true">
    <path fill="none" fillRule="evenodd" stroke="currentColor" d="M10.976 4.294C12.324 2.098 13.905 1 15.718 1c2.72 0 4.521 2.248 4.891 3.294.37 1.046.99 3.818-.998 7.717-1.987 3.9-7.166 6.989-8.635 6.989-1.468 0-6.897-3.504-8.662-6.989-1.765-3.484-1.42-6.51-.865-7.717C2.003 3.087 3.583 1 6.183 1c1.733 0 3.33 1.098 4.793 3.294z" />
  </svg>
);

export const MenuIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.2 6.15H.8a.8.8 0 1 0 0 1.61h18.4a.8.8 0 1 0 0-1.62m0-6.13H.8a.8.8 0 0 0 0 1.61h18.4a.8.8 0 1 0 0-1.61m0 12.25H.8a.8.8 0 1 0 0 1.62h18.4a.8.8 0 1 0 0-1.62" />
  </svg>
);

export const SearchIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" className={className} aria-hidden="true">
    <path d="M19.8 19 15 14a9 9 0 0 0 2-5.6 8.5 8.5 0 1 0-2.9 6.5l4.9 4.8.4.2a.6.6 0 0 0 .4-1M1.2 8.5a7.3 7.3 0 1 1 14.7 0 7.3 7.3 0 0 1-14.7 0" />
  </svg>
);

export const TransactionsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" className={className} aria-hidden="true">
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round">
      <path d="M1 4.565h19.13" />
      <path strokeLinejoin="round" d="M16.65.574l3.982 3.98-3.983 3.98" />
      <path d="M21 11.565H1.87" />
      <path strokeLinejoin="round" d="M5.35 7.574l-3.982 3.98 3.983 3.98" />
    </g>
  </svg>
);

export const SmartphoneIcon = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect x="6.75" y="2.75" width="10.5" height="18.5" rx="2.5" />
    <path d="M10.9 5.9h2.2" />
    <path d="M12 18.4h.01" />
  </svg>
);

/* Not hanamaru icons: hanamaru draws these two as raster images
   (icon/phone.png.webp, icon/triangle-down.png.webp) that do not exist on the
   dev server. Same shapes, drawn here so they need no request. */

export const PhoneIcon = ({ className }) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1z" />
  </svg>
);

export const CaretIcon = ({ className }) => (
  <svg width="8" height="4" viewBox="0 0 8 4" fill="currentColor" className={className} aria-hidden="true">
    <path d="M0 0h8L4 4z" />
  </svg>
);

export const AvatarIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#ffd3a8" />
    <circle cx="12" cy="10" r="4" fill="#fc4c02" />
    <path d="M4.5 19.5a8.5 8.5 0 0 1 15 0" fill="#fc4c02" />
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
